export const ADD_PRODUCT = "ADD_PRODUCT";
export const DECREASE_BY_ONE = "DECREASE_BY_ONE";
export const INCREASE_BY_ONE = "INCREASE_BY_ONE";
export const INCREASE_BY_QUANTITY = "INCREASE_BY_QUANTITY";
